import Vue from 'vue'
import Vuex from 'vuex'
import project from './modules/project'
import user from './modules/user'
import alerts from './modules/alerts'

Vue.use(Vuex)

export default new Vuex.Store({
	modules: {
		project,
		user,
		alerts
	}
})
